import React from 'react';
import useEventListener from '../../hooks/useEventListener';
import {
  ModalGeneral,
  ModalContent,
  ModalButtonContent,
  ModalClose,
} from './styles';

/**
 * @param props
 * @param {Boolean} props.open
 * @param {Html} props.children
 */
export default function Modal({
  open = false,
  openModal = () => null,
  children,
}) {
  const modalRef = React.useRef();

  useEventListener('mousedown', (event) => {
    if (event.defaultPrevented) return;
    if (modalRef?.current === event.target) openModal();
  });

  return (
    open && (
      <ModalGeneral open={open}>
        <ModalContent ref={modalRef}>
          <ModalButtonContent>
            <ModalClose onClick={openModal}>&times;</ModalClose>
            {children}
          </ModalButtonContent>
        </ModalContent>
      </ModalGeneral>
    )
  );
}
